import { FC } from 'react';
import { Badge, ListItemButton, ListItemText, Stack, useTheme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Notification } from '../../graphql/generated/graphql.ts';
import { DeepPartial } from '@apollo/client/utilities';
import { formatDistanceToNow } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../constants/paths.ts';
import { trackEvent } from '../../utils/analytics.ts';

export interface MessageListItemProps {
  notification?: DeepPartial<Notification>;
}

export const MessageListItem: FC<MessageListItemProps> = ({ notification }) => {
  const navigate = useNavigate();
  const { palette } = useTheme();
  const messageId = notification?._id || '';
  return (
    <ListItemButton
      onClick={() => {
        navigate(Paths.MESSAGE.replace(':id', messageId));
        trackEvent('message_open', { messageId });
      }}
    >
      <Stack spacing={1} sx={{ width: '100%' }}>
        <Stack direction="row" alignItems="center" spacing={1} justifyItems="end">
          {!notification?.readAt && (
            <Badge
              color="info"
              variant="dot"
              sx={{
                zIndex: 0
              }}
            />
          )}
          <ListItemText secondary={notification?.scheduledAt ? formatDistanceToNow(new Date(notification?.scheduledAt)) + ' ago' : ''} />
          <FontAwesomeIcon icon={faChevronRight} color={palette.grey['600']} />
        </Stack>
        {notification?.message?.title && (
          <ListItemText
            primary={notification.message.title}
            sx={{ whiteSpace: 'nowrap', overflow: 'hidden' }}
            primaryTypographyProps={{
              noWrap: true,
              textOverflow: 'ellipsis'
            }}
          />
        )}
        <ListItemText
          secondary={notification?.message?.body}
          secondaryTypographyProps={{
            noWrap: true,
            textOverflow: 'ellipsis'
          }}
          sx={{ whiteSpace: 'nowrap', overflow: 'hidden' }}
        />
      </Stack>
    </ListItemButton>
  );
};
